/* eslint-disable no-underscore-dangle */
import { message } from 'antd';
import * as CPurposesAPI from '../../../api/cPurposes';
import { setContentIsLoading, setDialogIsLoading } from '../loading';
import { sessionExpired } from '../auth';
import TEXTS from '../../../sections/cPurpose/_texts/index.texts';
import { getLang } from '../../../config/helpers';


export const SET_CPURPOSES_LIST = 'SET_CPURPOSES_LIST';
export const SELECT_CPURPOSE = 'SELECT_CPURPOSE';
export const ADD_CPURPOSE = 'ADD_CPURPOSE';
export const REMOVE_CPURPOSE = 'REMOVE_CPURPOSE';

const lang = getLang();


const setCPurposesList = value => ({
    type: SET_CPURPOSES_LIST,
    payload: value,
});

const setCPurposesListAsync = () => async (dispatch) => {
    dispatch(setContentIsLoading(true));
    try {
        const res = await CPurposesAPI.getByDoctor();
        dispatch(setCPurposesList(res.data));
    } catch (err) {
        sessionExpired(err, dispatch);
    }
    dispatch(setContentIsLoading(false));
};


const selectCPurposeAsync = id => async (dispatch) => {
    dispatch(setDialogIsLoading(true));
    try {
        const res = await CPurposesAPI.getById(id);
        dispatch(selectCPurpose(res.data));
    } catch (err) {
        sessionExpired(err, dispatch);
    }
    dispatch(setDialogIsLoading(false));
};

const addCPurpose = cPurpose => ({
    type: ADD_CPURPOSE,
    payload: cPurpose,
});

const addCPurposeAsync = cPurpose => async (dispatch) => {
    dispatch(setContentIsLoading(true));
    try {
        const res = await CPurposesAPI.create(cPurpose);
        dispatch(addCPurpose(res.data));
    } catch (err) {
        sessionExpired(err, dispatch);
    }
    dispatch(setContentIsLoading(false));
};

const removeCPurpose = id => ({
    type: REMOVE_CPURPOSE,
    payload: id,
});

const removeCPurposeAsync = id => async (dispatch) => {
    dispatch(setContentIsLoading(true));
    try {
        const res = await CPurposesAPI.remove(id);
        message.success(TEXTS.singleDeleteSuccess[lang]);
        dispatch(removeCPurpose(res.data._id));
    } catch (err) {
        // console.log(err);
        sessionExpired(err, dispatch);
    }
    dispatch(setContentIsLoading(false));
};

const selectCPurpose = value => ({
    type: SELECT_CPURPOSE,
    payload: value,
});


export {
    setCPurposesListAsync,
    addCPurposeAsync,
    addCPurpose,
    removeCPurpose,
    removeCPurposeAsync,
    selectCPurpose,
    selectCPurposeAsync,
};
